var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import classNames from "classnames";
import React from "react";
import { Button } from "../button/Button";
import { FollowIcon } from "./Icon";
import { followBtnCls, followBtnLightCls } from "./Button.less";
var FollowButton = /* @__PURE__ */ __name(function FollowButton2(_ref) {
  var _ref$displayType = _ref.displayType, displayType = _ref$displayType === void 0 ? "common" : _ref$displayType, _ref$href = _ref.href, href = _ref$href === void 0 ? null : _ref$href, _ref$obfuscate = _ref.obfuscate, obfuscate = _ref$obfuscate === void 0 ? true : _ref$obfuscate, _ref$isFollowed = _ref.isFollowed, isFollowed = _ref$isFollowed === void 0 ? false : _ref$isFollowed, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? null : _ref$onClick, children = _ref.children;
  var DISPLAY_TYPE_SETTINGS = {
    light: {
      className: followBtnLightCls,
      showIcon: false
    },
    common: {
      showIcon: true
    }
  };
  var settings = DISPLAY_TYPE_SETTINGS[displayType] || DISPLAY_TYPE_SETTINGS.common;
  return /* @__PURE__ */ React.createElement(Button, _extends({
    type: "ghost",
    className: classNames(followBtnCls, settings.className)
  }, href ? {
    isAnchor: true,
    href,
    obfuscate
  } : {}, {
    onClick
  }), settings.showIcon ? /* @__PURE__ */ React.createElement(FollowIcon, {
    isFollowed
  }) : null, children);
}, "FollowButton");
export {
  FollowButton
};
